import { render, staticRenderFns } from "./educationResultPop.vue?vue&type=template&id=0e132394"
import script from "./educationResultPop.vue?vue&type=script&lang=js"
export * from "./educationResultPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e132394')) {
      api.createRecord('0e132394', component.options)
    } else {
      api.reload('0e132394', component.options)
    }
    module.hot.accept("./educationResultPop.vue?vue&type=template&id=0e132394", function () {
      api.rerender('0e132394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationResultPop.vue"
export default component.exports